import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import Card from 'components/CreateCard/Card'
import empty from './mainpage-empty.svg'

const Menu = styled.div`
    display: flex;
    justify-content: center;

    > div {
        padding: 30px 100px;
        width: 400px;
        height: auto;
        font-size: 16px;
        line-height: 1.5;

        span {
            margin-left: -15px;
        }
    }

    > div:first-child {
        border-right: 1px solid #cadce0;
    }

    > div:last-child {
        border-left: 1px solid #cadce0;
    }
`

const Title = styled.div`
    color: #4a4a4a;
    font-family: Helvetica;
    font-weight: 700;
    font-size: 24px;
    margin: 40px 0;
    text-align: center;
`

const images = [
    {
        icon: 'list',
        name: 'lst'
    },
    {
        icon: 'excel',
        name: 'excel'
    }
]

const ModuleEmpty = ({isDesigner, handleOpen, mobile, intl}) => (
    <React.Fragment>
        {!mobile && isDesigner ?
            <React.Fragment>
                <Title>
                    {intl.formatMessage({id: "main.module_empty"})}
                </Title>
                <Menu>
                    {images.map((item, index) =>
                        <Card key={index}
                            icon={item.icon}
                            name={item.name}
                            onClick={() => handleOpen(item.name)}
                            color={item.name === 'excel' ? '#ffc300' : ''}
                            title={item.name}
                        />
                    )}
                </Menu>
            </React.Fragment>
            :
            <img src={empty} alt='' style={{margin: 'auto 15px'}}/>
        }
    </React.Fragment>
)

export default injectIntl(ModuleEmpty)
